/* unplugin-vue-components disabled */import { render } from "./detailsShop.vue?vue&type=template&id=46e9ff77&scoped=true"
import script from "./detailsShop.vue?vue&type=script&lang=js"
export * from "./detailsShop.vue?vue&type=script&lang=js"

import "./detailsShop.vue?vue&type=style&index=0&id=46e9ff77&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e9ff77"]])

export default __exports__